import { render, staticRenderFns } from "./SignificationCouleur.vue?vue&type=template&id=15cd8dc4&scoped=true&"
import script from "./SignificationCouleur.vue?vue&type=script&lang=js&"
export * from "./SignificationCouleur.vue?vue&type=script&lang=js&"
import style0 from "./SignificationCouleur.vue?vue&type=style&index=0&id=15cd8dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd8dc4",
  null
  
)

export default component.exports